var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cartHighDemandMessage && _vm.showMessage)?_c('div',{staticClass:"bg-lighter-gray px-4 py-6 flex"},[_c('InfoIcon',{staticClass:"inline-block h-4 shrink-0 leading-0 mr-3 mt-[3px]"}),_vm._v(" "),_c('div',{staticClass:"leading-4 fluid-xs"},[_vm._v(_vm._s(_vm.$t('cart.reservationNotAvailable')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }